export const styles = (theme) => ({
  alertDialog: {
    '& .confirm': {
      color: 'white',
      backgroundColor: `${theme.palette.primary.main} !important`,
    },
  },
});
